import React from "react"
import styles from "./styles.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class IconBox extends React.Component {
  render() {
    const { icon, text } = this.props
    if(text == null) return null;
    return (
      <div className={styles.container}>
        <div className={styles.iconWrapper}>
          <FontAwesomeIcon className={styles.icon} icon={icon} />
        </div>
        <p className={styles.iconText}>{text}</p>
      </div>
    )
  }
}

export default IconBox



// WEBPACK FOOTER //
// src/components/IconBox/index.jsx